import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KbinConfirm from './KbinConfirm';
import ColInput from './ColInput';
import BottomButtons from './BottomButtons';
import {Owner,KbinColabo} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
import Title from './Title';
import Loading from './Loading';

interface KbinInputProps {
	owner:Owner,
}

const KbinInput = (props:KbinInputProps)=> {
	const classes = useStyles();

	const defValues:KbinColabo = {
		jiki: "",
		title: "",
		artists: "",
		memo: "",
		customer_id: 0,
		banner: "9",
		target: "9",
	}
	const [states, setStates] = useState({
		values: defValues,
		errors: [] as string[],
		isLoading: false,
		isConfirm: false,
		isSuccess: false,
	});
	const [toast,setToast] = useState("");

	const handleModalClose = ()=>{
		setStates({...states,"isConfirm":false});
	};

	const handleChange = (name: keyof KbinColabo) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, values:{...states.values,[name]: event.target.value }});
	};
	const handleChangeRadio = (name: keyof KbinColabo) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, values:{...states.values,[name]: event.target.value }});
	};

	const change = (name:keyof KbinColabo,value:string)=>{
		setStates(prev=>({...prev,"values":{...prev.values,[name]:value}}));
	}
	const addError = (name:keyof KbinColabo,isError:boolean) =>{
		setStates(prev => {
			const errors = [...prev.errors];
			if( isError ){
				if( !errors.includes(name) ){
					errors.push( name );
				}
			} else {
				if( errors.includes(name) ){
					const index = errors.findIndex((v) => v===name);
					errors.splice(index,1);
				}
			}
			return { ...prev, errors: errors }
		});
	}

	const closeToast = ()=>{
		setToast("");
	}
	const validate = ()=>{
		const memo = states.values.memo.trim();
		if( memo==='' ){
			setToast("コラボ内容の説明を入力してください。");
		} else {
			setStates({...states,"isConfirm":true});
		}
	}
	const send = ()=>{
		setStates({...states,"isLoading":true});
		Ajax.setEditorId(props.owner.owner_id);
		Ajax.send("kbin/send",{...states.values,customer_id:props.owner.customer.customer_id},(res:any)=>{
			if( res.ok ){
				//isThanks = true;
				setStates({values:defValues,errors:[],"isLoading":false,"isConfirm":false,"isSuccess":true});
				window.scrollTo(0, 0);
			} else {
				setStates({...states,"isLoading":false,"isConfirm":false,"isSuccess":false});
				setToast("送信に失敗しました。");
			}
		});
	}
	useEffect( ()=>{
		setStates({values:{
			jiki: "",
			title: "",
			artists: "",
			memo: "",
			banner: "9",
			target: "9",
			customer_id: 0,
		},errors:["memo"],"isLoading":false,"isConfirm":false,"isSuccess":false});
		window.scrollTo(0,0);
	},[]);

	return (
		<div className={classes.root+" "+classes.policy}>
			{states.isSuccess ? (
				<Paper className={classes.paper}>
					<div style={{marginBottom:"3em"}}>
						<Title text="Ｋ便鉄道コラボのご相談をうけたまわりました。" size={2}/>
						<div className={classes.section}>
							<p><b>store@retro-biz.com</b>から確認メールを送信いたしました。</p>
							<p>
								担当者が予定を確認した上で予約確定となります。<br/>
								なるべく早めに返信いたしますので今しばらくお待ち下さい。（通常１営業日以内）
							</p>
						</div>
					</div>
				</Paper>
			):(
			<React.Fragment>
				<Paper className={classes.paper}>
					<Title text="Ｋ便鉄道コラボ" size={1} icon="store"/>
					<div>
						<img src="https://58yy5w7p.user.webaccel.jp/img/default/kbin/kbin_colabo.png" alt="Ｋ便鉄道コラボ" style={{width:'100%'}}/>
					</div>
					<div style={{marginBottom:"4em"}}>
						<p style={{color:'#ff0000'}}>架空ストアのキャンペーン企画「架空のＫ便鉄道」は本年で終了予定です。<br/>
						コラボレーション相手の募集は締め切りました。</p>
					</div>
					<div style={{marginBottom:"4em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								架空のＫ便鉄道とは？
							</Stack>
						</h2>
						<div style={{marginBottom:"1em"}}>
							通販時のネックになりやすい送料や支払手数料などの諸費用が無料になるキャンペーンです。<br/>
							お客様のご注文に対象商品が一つでも入っていれば、通常はお客様負担となる送料も支払手数料も無料（架空ストア負担）になります。<br/>
							架空ストア外のイベントとコラボする形で、だいたい月１回くらいの頻度で開催しています。<br/>
							<div style={{textAlign:'right'}}>
								<a href={process.env.REACT_APP_DEPARTURL + "/kbin"} target="_blank"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>これまでのコラボの実績と予告はこちら</Button></a>
							</div>
						</div>
					</div>
					<div style={{marginBottom:"4em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								どんなコラボが可能？
							</Stack>
						</h2>
						<div style={{marginBottom:"1em"}}>
							同人誌イベントの開催期間中に、そのイベントに参加している作家さんの作品をＫ便鉄道の対象とすることで、
							送料や手数料を気にすることなくお客さんが作品を購入することができます。<br/>
							架空ストアでは複数の作家さんの作品を一緒に購入できますし、こうしたイベントにはうってつけです。<br/>
						</div>
					</div>
					<div style={{marginBottom:"2em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								募集要項
							</Stack>
						</h2>
						<div style={{marginBottom:"2em"}}>
							以下の内容に合わない場合はご相談下さい。何とかなるかもしれません。<br/>
						</div>
					</div>
					<table style={{marginBottom:"2em"}} className="visitTimeTable">
						<tbody>
						<tr>
							<th colSpan={2}>架空のＫ便鉄道コラボ　募集要項</th>
						</tr>
						<tr>
							<td className='week'>申込の資格</td>
							<td style={{textAlign:'left'}}>
								コラボは一次創作のイベントのみ対象といたします<br/>
								イベントの主催者がお申込み下さい<br/>
								<div style={{color:'#666666',marginTop:'0.5em',fontSize:'90%'}}>
									・主催者が架空ストアをご利用中の作家でなくても構いません
								</div>
							</td>
						</tr>
						<tr>
							<td className='week'>開催期間</td>
							<td style={{textAlign:'left'}}>
								7～10日間
								<div style={{color:'#666666',marginTop:'0.5em',fontSize:'90%'}}>
									・ご希望の期間をお知らせ下さい<br/>
									・コラボの開催期間は、イベントの開催期間より長く設定することができます<br/>
								</div>
							</td>
						</tr>
						<tr>
							<td className='week'>参加作家</td>
							<td style={{textAlign:'left'}}>
								主催者は開催の1週間前までに参加作家をお知らせ下さい<br/>
								<div style={{color:'#666666',marginTop:'0.5em',fontSize:'90%'}}>
									・主催者から連絡のあった作家さんだけが対象となります<br/>
									・参加作家は架空ストアの作家登録が必要です<br/>
									・参加作家の人数に制限はありません<br/>
								</div>
							</td>
						</tr>
						<tr>
							<td className='week'>参加作品</td>
							<td style={{textAlign:'left'}}>
								参加作家は開催前日までに参加作品を選択して下さい<br/>
								<div style={{color:'#666666',marginTop:'0.5em',fontSize:'90%'}}>
									・参加作品は「Ｋ便鉄道参加」で選択できます<br/>
									・主催者は、選択できる作品のジャンルや個数などに条件をつけることもできます<br/>
									　例：小説だけ、今年発売された作品だけ、２作品以内、など<br/>
								</div>
							</td>
						</tr>
						<tr>
							<td className='week'>納品の期限</td>
							<td style={{textAlign:'left'}}>
								原則として対象作品は開催期間の前日までに架空ストアへの納品手続きを済ませてください<br/>
							</td>
						</tr>
						</tbody>
					</table>

					<div style={{marginBottom:"8em"}}>
						<h2 style={{marginBottom:'1em'}}>
							<Stack direction="row" spacing={2}>
								<ContactSupportIcon/>
								注意事項
							</Stack>
						</h2>
						<div style={{marginBottom:"2em",color:'brown',backgroundColor:'#FFEEEE',padding:'1em'}}>
							・コラボのご相談および開催について架空ストアがイベント主催者および参加作家に料金を請求することはありません。<br/>
							・架空ストアからイベント主催者への謝礼報酬や対価の支払いもありません。<br/>
							・やむをえない事情でコラボが中止になった場合、架空ストアもイベント主催者も互いに責を問わないものとします。<br/>
						</div>
					</div>
				</Paper>
			</React.Fragment>
			)}
			<KbinConfirm send={send} close={handleModalClose} isOpen={states.isConfirm} values={states.values}/>
			<Toast close={closeToast} mes={toast}/>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default KbinInput;
